<template>
  <div class="add-adverts">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="adverts.id ? $t('addAdverts.edit') : $t('addAdverts.add')"
      :visible.sync="localDialogVisible"
      width="680px"
      top="9vh"
      @open="openDialog"
      @closed="closeDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form ref="adverts" :model="adverts" :rules="rules" label-position="top">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('addAdverts.title')" prop="head">
                <el-input v-model="adverts.head" :placeholder="$t('addAdverts.pTitle')" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('addAdverts.uploadMedia')" prop="url">
                <media-upload
                  v-model="adverts.url"
                  :value-type="numericAdvertType"
                  :image-max-size="5"
                  :video-max-size="100"
                  :tips="uploadTips"
                  @success="handleMediaSuccess"
                  @remove="handleMediaRemove"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('equipmentAdvertConfig.mediaUrl')" prop="url">
                <el-input
                  v-model="adverts.url"
                  :placeholder="$t('equipmentAdvertConfig.mediaUrlPlaceholder')"
                  autocomplete="off"
                  @input="handleUrlInput"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="media-type-tip">
                {{ $t("equipmentAdvertConfig.mediaType") }}: {{ mediaTypeLabel }}
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emitClose('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MediaUpload from "@/components/common/MediaUpload.vue";

const inferAdvertType = url => (/\.(mp4|avi|mov|wmv|webm)$/i.test(url || "") ? 1 : 0);

export default {
  name: "AddAdverts",
  components: {
    MediaUpload
  },
  props: {
    adverts: Object,
    dialogAdverts: Boolean
  },
  data() {
    return {
      loadingForm: false,
      rules: {
        head: [
          {
            required: true,
            message: this.$t("addAdverts.pTitle"),
            trigger: "blur"
          }
        ],
        url: [
          {
            required: true,
            message: this.$t("equipmentAdvertConfig.mediaUrlPlaceholder"),
            trigger: "blur"
          }
        ]
      },
      uploadTips: [
        this.$t("addAdverts.waddFileTips1"),
        "Images: Max 5MB | Videos: Max 100MB",
        this.$t("addAdverts.waddFileTips3"),
        this.$t("addAdverts.waddFileTips4")
      ]
    };
  },
  computed: {
    localDialogVisible: {
      get() {
        return this.dialogAdverts;
      },
      set(value) {
        if (!value) {
          this.emitClose("");
        }
      }
    },
    numericAdvertType() {
      const advertType = Number(this.adverts.type);
      return Number.isNaN(advertType) ? 0 : advertType;
    },
    mediaTypeLabel() {
      return this.numericAdvertType === 1 ? this.$t("addAdverts.video") : this.$t("addAdverts.image");
    }
  },
  methods: {
    openDialog() {
      if (!this.adverts.id) {
        this.adverts.type = inferAdvertType(this.adverts.url);
      } else {
        this.adverts.type = inferAdvertType(this.adverts.url || "") === 1 ? 1 : Number(this.adverts.type || 0);
      }
    },
    closeDialog() {
      if (this.$refs.adverts) {
        this.$refs.adverts.clearValidate();
      }
    },
    emitClose(state) {
      this.$emit("cancel", false, state);
    },
    handleUrlInput(url) {
      this.adverts.type = inferAdvertType(url);
    },
    handleMediaSuccess(data) {
      this.adverts.url = data.url;
      this.adverts.type = data.type;
    },
    handleMediaRemove() {
      this.adverts.url = "";
      this.adverts.type = 0;
    },
    submitForm() {
      this.$refs.adverts.validate(valid => {
        if (!valid) {
          return;
        }
        this.loadingForm = true;
        const payload = {
          id: this.adverts.id,
          head: this.adverts.head,
          type: this.numericAdvertType,
          url: this.adverts.url
        };
        const url = this.adverts.id ? this.$url.Adverts.update : this.$url.Adverts.insert;
        const method = this.adverts.id ? this.$method.put : this.$method.post;
        this.$api
          .request(url, method, payload)
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "success"
              });
              this.emitClose(this.adverts.id ? "update" : "save");
            }
          })
          .finally(() => {
            this.loadingForm = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.media-type-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
</style>
